export const NEW_OUTLOOK_PROMO_DIALOG_LIGHTNINGID = 'NewOutlookPromoDialog';
export const NEW_OUTLOOK_LEARN_MORE_URL = 'https://go.microsoft.com/fwlink/?linkid=2268191';
